<template>
  <div>
    <h4 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
      {{ t('app.subscription.renewal.step3_title') }}
    </h4>

    <div class="space-y-4">
      <!-- Payment Date -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          {{ t('app.subscription.renewal.payment_date') }}
        </label>
        <input 
          :value="modelValue.paymentDate"
          @input="$emit('update:paymentDate', ($event.target as HTMLInputElement).value)"
          type="datetime-local"
          class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
        >
      </div>

      <!-- Proof Image URL -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          {{ t('app.subscription.renewal.proof_image') }}
        </label>
        <input 
          :value="modelValue.proofImageUrl"
          @input="$emit('update:proofImageUrl', ($event.target as HTMLInputElement).value)"
          type="url"
          placeholder="https://..."
          class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
        >
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          URL de la imagen del comprobante (opcional)
        </p>
      </div>

      <!-- Notes -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          {{ t('app.subscription.renewal.notes') }}
        </label>
        <textarea 
          :value="modelValue.notes"
          @input="$emit('update:notes', ($event.target as HTMLTextAreaElement).value)"
          rows="3"
          :placeholder="t('app.subscription.renewal.notes_placeholder')"
          class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

interface Props {
  modelValue: {
    paymentDate: string
    proofImageUrl: string
    notes: string
  }
}

defineProps<Props>()

defineEmits<{
  'update:paymentDate': [value: string]
  'update:proofImageUrl': [value: string]
  'update:notes': [value: string]
}>()

const { t } = useI18n()
</script>
